import { Component, OnInit, Input } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UtilsService } from "src/app/core/services/utils.service";

@Component({
	selector: "app-table-filter",
	templateUrl: "./table-filter.component.html",
})
export class TableFilterComponent implements OnInit {
	filterForm: FormGroup;
	keyword: string = "";

	constructor(
		private utilsService: UtilsService,
		private fb: FormBuilder,
		private router: Router,
		private route: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.route.queryParams.subscribe((params: Params) => {
			if (params["keyword"] != undefined) {
				this.keyword = params["keyword"];
			} else {
				this.keyword = "";
			}
			this.filterForm = this.fb.group({
				keyword: [this.keyword, this.utilsService.noWhiteSpaceValidator],
			});
		});
	}

	onFilterSubmit(): void {
		this.keyword = this.filterForm.get("keyword").value.trim();
		// Use current URL path and update query params globally
		this.router.navigate([], { queryParams: { keyword: this.keyword || null }, queryParamsHandling: "merge" });
	}
}
